import React, { Component, useEffect, useState } from 'react';
import { publicIpv4, publicIpv6 } from "public-ip";
import bg1 from '../images/bg1.png';
import bgvideo from '../images/bg3.mp4';
import logo from '../images/weokaslogin.svg';
import okaslogo from '../images/okaslogo.svg';
import okasweb from '../images/okasweb.svg';
import okasmail from '../images/okasmail.svg';
import TextField from "@mui/material/TextField";
import '../css/loginform.css';
import { Link, Navigate } from 'react-router-dom';
import Loader from '../components/loader';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as ActionTypes from '../actions/types';
import SnackBar from '../containers/SnackBar';
import errorText from '../errorText';
import { Box, fontSize } from '@mui/system';
import { Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { modulesDataSI } from '../constant/permissions';
// import { fetchApi } from '../utils/api';


const LoginView = (props) => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [registeredEmail, setRegisteredEmail] = useState("");
    const [nameerror, setNameError] = useState('');
    const [phoneerror, setPhoneError] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [username, setUsername] = useState('');
    const [disabledvalue, setDisabledValue] = useState('');
    const [loader, setLoader] = useState(false);
    const [checkuserApidataa, setCheckuserApidata] = useState([]);
    const [snackbarActive, setSnackbarActive] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [linkActivationForm, setLinkActivationForm] = useState(true);
    const [confirmWindow, setConfirmWindow] = useState(false);
    const [processed, setProcessed] = useState(false);
    const [browserDetails, setBrowserDetails] = useState({ locationApi: "Unknown" });
    const [locationApi, setLocationApi] = useState("");
    const [browserLocation, setBrowserLocation] = useState({});
    const [newUserEmail, setNewUserEmail] = useState("")
    // const [platform, setPlatform] = useState(localStorage.getItem("selectedPlatform") || "");
    // const [platformError, setPlatformError] = useState(false);


    const reduxState = useSelector((state) => state);
    const dispatch = useDispatch();
    const successBarActivate = (data) => dispatch({ type: ActionTypes.SUCCESSBAR, data });
    const userNameStyleActivate = (data) => dispatch({ type: ActionTypes.USERNAMESTYLE, data });
    const reuserNameStyleActivate = (data) => dispatch({ type: ActionTypes.REUSERNAMESTYLE, data });
    const userTypeStyleActivate = (data) => dispatch({ type: ActionTypes.USERTYPESTYLE, data });


    const confirmWindowClose = () => {
        setConfirmWindow(false);
    };

    const setTokenAndRedirect = async (data, usertype, reusername) => {
        console.log(data);

        localStorage.setItem("name", reusername);
        localStorage.setItem("email", username);
        localStorage.setItem("csrftoken", document.cookie.match(/csrftoken=([^;]*)/)?.[1] || "");
        localStorage.setItem("auth", data.token);


        userNameStyleActivate(username);
        reuserNameStyleActivate(reusername);
        userTypeStyleActivate(usertype);


        if (localStorage.getItem('auth')) {
            // console.log("data", checkuserApidataa);
            const userType = data.User_Type;
            const userSource = data.sourceType;
            const userData = await checkuserApi()
            const permissions = userData?.permissions?.[0] || {};
            const firstModuleKey = Object.keys(permissions)[0];
            const firstModulePermissions = permissions[firstModuleKey];
            // console.log("🧩 First Module:", firstModuleKey);
            // console.log("🔐 First Module Permissions:", firstModulePermissions);
            // console.log(userSource)
            //alert(userSource)
            //alert(userType)
            

            if (userType === '2') {
                window.location.href = "/projectdetail";
            } else if (userType === '1') {
                window.location.href = "/dashboard";
            } else if (userType === '3') {
                window.location.href = "/dashboardnew";
            }
        

            else if (userType === '4') {

                let redirectLink = `/${firstModuleKey}`;

                if (userSource === "SI") {
                    if (firstModuleKey === "support") redirectLink = "/support";
                    else if (firstModuleKey === "project manager") redirectLink = "/projectmanager";
                    else if (firstModuleKey === "inventory") redirectLink = "/regOkas";
                    else if (firstModuleKey === "user") redirectLink = "/userpage2";
                    else if (firstModuleKey === "role") redirectLink = "/roles2";
                    else if (firstModuleKey === "project detail") redirectLink = "/projectdetail";
                    else if (firstModuleKey === "office location") redirectLink = "/officelocation";
                } else if (userSource === "Distributor") {
                    // Distributor-specific redirection logic
                    if (firstModuleKey === "support") redirectLink = "/support2";
                    else if (firstModuleKey === "role") redirectLink = "/roles";
                    else if (firstModuleKey === "user") redirectLink = "/userpage";
                    else if (firstModuleKey === "member licence") redirectLink = "/memberlicence";
                    else if (firstModuleKey === "system integrator") redirectLink = "/systemintegratoradd";
                    else if (firstModuleKey === "okas inventory") redirectLink = "/assignokasbox";

                } else {
                    redirectLink = "/support"; // Default fallback if needed

                }
                // Then perform the redirection
                window.location.href = redirectLink;
            }

        }
    };

    const getCookie = (c_name) => {
        const cookies = document.cookie.split("; ");
        for (let cookie of cookies) {
            const [name, value] = cookie.split("=");
            if (name === c_name) {
                return decodeURIComponent(value);
            }
        }
        return "";
    };

    const checkuserApi = async () => {

        const TokenValue = `Token ${localStorage.getItem("auth")}`;

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Access-Control-Allow-Origin': "*",
        };
        // alert("sdfsdfsdf")
        let response = await fetch('/we/we/userCheckApi/', { method: "GET", headers })
        let checkuserApidata = await response.json();

        if (checkuserApidata.status !== '200') {

            localStorage.removeItem('auth');
            window.location.href = '/login';
        }
        return checkuserApidata


    };



    useEffect(() => {
        (async () => {
            try {
                const ip = await publicIpv4() || await publicIpv6();
                setLocationApi(ip);

                fetch(`http://ip-api.com/json/${ip}?fields=status,message,country,countryCode,region,regionName,city,zip,lat,lon,timezone,isp,org,as,query`)
                    .then(response => response.json())
                    .then(data => {
                        // console.log("ip",data);
                        setBrowserLocation(data);
                    });
            } catch (error) {
                console.error("Error fetching location data:", error);
            }
        })();

        browserDediction();
        // checkuserApi();
        checkExpirationLink();

        if (window.location.pathname.includes("session-timeout")) {
            callError("Session Timeout");
        }
    }, []); // Runs once when component mounts



    const callError = (message) => {
        setErrorMessage(message);
        setLoader(false);

        setTimeout(() => {
            if (message === "You have a active session.Please go to our homepage.") {
                window.location.href = '/';
            }
            setErrorMessage('');
        }, 4000);
    };


    const onSubmitbutton = (e) => {
        e.preventDefault();
        const trimmedUsername = username.trim();
        const data = {
            "si_userName": username,
            "password": password,
        };
        const headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken')
        };
        if (trimmedUsername.length < 1) {
            callError("Please fill Username");
        } else if (password.length < 1) {
            callError("Please fill Password");
        } else {
            setLoader(true);

            fetch("/we/we/loginview/", {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);
                    if (data.status == 400) {
                        callError(data.message);
                    } else if (data.status == 200) {
                        setTokenAndRedirect(data, username, data.User_Type, data.si_name);

                    } else {
                        callError("Incorrect Credentials");
                    }
                    setLoader(false);
                }).catch(err => {
                    console.log(err)
                });
        }
    };

    // const onSubmitNewAccount = (e) => {
    //     e.preventDefault()
    //     if (password === confirmPassword && password !== "" && confirmPassword !== "") {
    //         if (linkActivationForm) {
    //             const regex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
    //             if (regex.test(password)) {
    //                 activateNewUser();
    //             } else {
    //                 callError("Password must contain at least 1 lowercase letter, 1 uppercase letter, 1 number, 1 special character and should be of length between 8 and 50 characters.");
    //             }
    //         } else {
    //             callError("Activation link has expired or is invalid.");
    //         }
    //     } else {
    //         callError("Password doesn't match.");
    //     }
    // };



    const onSubmitNewAccount = (e) => {
        e.preventDefault();

        if (password === confirmPassword && password !== "" && confirmPassword !== "") {
            if (linkActivationForm) {
                //do something usefull here
                if (password.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/)) {
                    activateNewUser()
                } else {
                    callError("Password must contains at least 1 lowercase letter, 1 uppercase letter, 1 number, 1 special character and should be of length between 8 and 50 characters")
                }
            } else {
                callError("Activation link has expired or invalid")
            }
        } else {
            callError("Password doesn't match.")
        }

    }


    const activateNewUser = async () => {


        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        };
        const activationLink = window.location.pathname.slice(-16);
        const data = {
            si_email: newUserEmail,
            si_password: password,
            activation_link: activationLink,
            browserDetails: {
                ...browserDetails,
                locationApi,
                browserLocation
            }
        };

        setLoader(true);

        if (!localStorage.getItem("auth")) {
            try {
                const response = await fetch(`/we/we/setPasswordApi/?url=${activationLink}`, {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(data),
                });

                const result = await response.json();
                // console.log(result);

                if (result.message === 'success') {
                    setConfirmWindow(true);
                    setLoader(false);
                } else {
                    callError(result.data[0]);
                    setLinkActivationForm(false);
                }
            } catch (error) {
                // console.error("Error:", error);
                callError("Something went wrong. Please try again.");
                setLoader(false);
            }
        } else {
            callError("You have an active session. Please go to our homepage.");
        }
    };

    const checkExpirationLink = async (



    ) => {
        if (window.location.pathname.includes("/login/activateuser/") || window.location.pathname.includes("/login/forgotpassword/")) {
            const TokenValue = 'Token ' + localStorage.getItem("auth");
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': TokenValue,
                'X-CSRFToken': localStorage.getItem('csrftoken')
            };
            try {
                const response = await fetch(`/we/we/setPasswordApi/?url=${window.location.pathname.slice(-16)}`, {
                    method: "GET",
                    headers: headers
                });
                const data = await response.json();
                // console.log(data);
                if (data.message === 'success') {
                    setNewUserEmail(data.data[0].email);
                } else {
                    callError(data.data[0]);
                    setLinkActivationForm(false);
                }
            } catch (error) {
                // console.error("Error:", error);
                callError("Something went wrong. Please try again.");
            }
        }
    };


    const browserDediction = () => {
        let objAgent = navigator.userAgent;
        let objbrowserName = navigator.appName;
        let objfullVersion = '' + parseFloat(navigator.appVersion);
        let objBrMajorVersion = parseInt(navigator.appVersion, 10);
        let objOffsetVersion, objOffsetName, ix;

        if ((objOffsetVersion = objAgent.indexOf("Chrome")) !== -1) {
            objbrowserName = "Chrome";
            objfullVersion = objAgent.substring(objOffsetVersion + 7);
        } else if ((objOffsetVersion = objAgent.indexOf("MSIE")) !== -1) {
            objbrowserName = "Microsoft Internet Explorer";
            objfullVersion = objAgent.substring(objOffsetVersion + 5);
        } else if ((objOffsetVersion = objAgent.indexOf("Firefox")) !== -1) {
            objbrowserName = "Firefox";
        } else if ((objOffsetVersion = objAgent.indexOf("Safari")) !== -1) {
            objbrowserName = "Safari";
            objfullVersion = objAgent.substring(objOffsetVersion + 7);
            if ((objOffsetVersion = objAgent.indexOf("Version")) !== -1) {
                objfullVersion = objAgent.substring(objOffsetVersion + 8);
            }
        } else if ((objOffsetName = objAgent.lastIndexOf(' ') + 1) < (objOffsetVersion = objAgent.lastIndexOf('/'))) {
            objbrowserName = objAgent.substring(objOffsetName, objOffsetVersion);
            objfullVersion = objAgent.substring(objOffsetVersion + 1);
            if (objbrowserName.toLowerCase() === objbrowserName.toUpperCase()) {
                objbrowserName = navigator.appName;
            }
        }
        if ((ix = objfullVersion.indexOf(";")) !== -1) {
            objfullVersion = objfullVersion.substring(0, ix);
        }
        if ((ix = objfullVersion.indexOf(" ")) !== -1) {
            objfullVersion = objfullVersion.substring(0, ix);
            objBrMajorVersion = parseInt(objfullVersion, 10);
        }
        if (isNaN(objBrMajorVersion)) {
            objfullVersion = '' + parseFloat(navigator.appVersion);
            objBrMajorVersion = parseInt(navigator.appVersion, 10);
        }

        const details = {
            browserName: objbrowserName,
            fullVersion: objfullVersion,
            majorVersion: objBrMajorVersion,
            appName: navigator.appName,
            userAgent: navigator.userAgent,
            os: osDediction(),
            date: {
                date: new Date().toLocaleDateString(),
                time: new Date().toLocaleTimeString()
            }
        };

        setBrowserDetails(details);
    };


    const osDediction = () => {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
        const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
        const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

        if (macosPlatforms.includes(platform)) {
            return 'Mac OS';
        } else if (iosPlatforms.includes(platform)) {
            return 'iOS';
        } else if (windowsPlatforms.includes(platform)) {
            return 'Windows';
        } else if (/Android/.test(userAgent)) {
            return 'Android';
        } else if (/Linux/.test(platform)) {
            return 'Linux';
        } else {
            return 'Unknown OS';
        }
    };

    const onForgetPassword = async (  e) => {
        e.preventDefault();

        if (errorText('email', registeredEmail) === 'Error') {
            callError("Not a valid email");
            return;
        }

        setLoader(true);
        const tokenValue = `Token ${localStorage.getItem("auth")}`;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': tokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        };
        if (!localStorage.getItem("auth")) {
            try {
                const response = await fetch(`/we/we/forgotPasswordApi/?email=${registeredEmail}`, {
                    method: "GET",
                    headers: headers,
                });
                const data = await response.json();
                // console.log(data);
                if (data.message === "failure") {
                    callError(data.data[0]);
                    setLoader(false);
                } else if (data.message === "success") {
                    setProcessed(true);
                    setLoader(false);
                    if (data.data[0] === "Email sent twice.") {
                        callError("Email sent again.");
                    }
                }
            } catch (error) {
                // console.error("Error:", error);
                callError("Something went wrong. Please try again.");
                setLoader(false);
            }
        } else {
            callError("You have an active session. Please go to our homepage.");
        }
    };



    const ConfirmationWindow = ({ confirmWindow }) => {
        if (!confirmWindow) return null;

        return (
            <>
                <img src={logo} className="img-responsive centeriimgs" style={{ maxWidth: "400px" }} alt="Logo" />
                <div className="modal-body modfields" style={{ paddingTop: '10px' }}>
                    <div className="content mt-5 centerheadingfd">
                        Your password has been successfully updated.
                    </div>
                    <br />
                    <br />
                </div>
                <div className="centerdiv">
                    <button type="submit" className="btn allbtn" style={{ backgroundColor: "#15599F" }}>
                        <a style={{ float: "center", paddingTop: '10px', color: "white" }} href="/login">
                            Login
                        </a>
                    </button>
                </div>
            </>
        );
    };

    const typeOfLogin = () => {
        let formPage = "";
        if (confirmWindow) {
            return null;
        }
        if (window.location.pathname === "/login" || window.location.pathname === "/login/session-timeout") {
            formPage = (
                <form className="loginForm"
                    // onSubmit={onSubmitbutton}
                    onSubmit={(e) => onSubmitbutton(e, username, password, callError, setTokenAndRedirect, setLoader)}
                >
                    <img src={logo} className="img-responsive centeriimgs" style={{ maxWidth: "400px" }} />
                    <div className="content mt-5 centerheadingfd">Welcome! Please login to your account</div>
                    {errorMessage !== '' ? <div style={{ maxWidth: '400px' }} className="alert alert-danger text-center" role="alert">{errorMessage}</div> : null}
                    <div className="modal-body modfields" style={{ paddingTop: '10px' }}>

                        <TextField
                            label="Username"
                            type="text"
                            name="username"
                            id="name"
                            placeholder="Enter Email"
                            className={nameerror ? nameerror : ""} // Keep the same class if needed
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            error={!!nameerror} // Shows error styling if nameerror exists
                            helperText={nameerror ? "Invalid username" : ""} // Optional error message
                            fullWidth
                            variant="standard" // Use "filled" or "standard" if needed
                        //  disabled={!platform} // Disable if platform is not selected
                        />

                        <br /><br />
                        <TextField
                            type="password"
                            name="password"
                            label="Password"
                            className={phoneerror ? phoneerror : ""}
                            value={password}
                            onChange={(e) => {
                                if (password.length < 50) {
                                    setPassword(e.target.value);
                                }
                            }}
                            autoComplete="off"
                            fullWidth
                            variant="standard"
                        // disabled={!platform} // Disable if platform is not selected
                        />
                        <div>
                            <a style={{ float: "center", marginTop: "5px" }} href="/login/forget-password">Forgot Password?</a>
                        </div>
                        <br /><br />
                    </div>
                    <div className="centerdiv">
                        <button
                            type="submit"
                            className="btn allbtn"
                            value="Login"
                            style={{ backgroundColor: "#15599F" }}
                            onClick={(e) => onSubmitbutton(e, username, password, callError, setTokenAndRedirect, setLoader)}
                        >
                            Login
                        </button>
                    </div>
                </form>
            );
        } else if (window.location.pathname.includes('/login/activateuser')) {
            formPage = (
                <form className="loginForm" onSubmit={onSubmitNewAccount}>
                    <img src={logo} className="img-responsive centeriimgs" style={{ maxWidth: "400px" }} />
                    <div className="content mt-5 centerheadingfd">Welcome! Please activate your new account</div>
                    {errorMessage !== '' ? <div style={{ maxWidth: '400px' }} className="alert alert-danger text-center" role="alert">{errorMessage}</div> : null}
                    <div className="modal-body modfields" style={{ paddingTop: '10px' }}>
                        <TextField
                            type="password"
                            name="password"
                            label="New Password"
                            className={phoneerror ? phoneerror : ""}
                            value={password}
                            onChange={(e) => {
                                if (password.length < 50) { setPassword(e.target.value); }
                            }}
                            required
                            autoComplete="off"
                            fullWidth
                            variant="standard"
                        />
                        <br /><br />
                        <TextField
                            type="password"
                            name="confirmpassword"
                            label="Confirm New Password"
                            className={phoneerror ? phoneerror : ""}
                            value={confirmPassword}
                            onChange={(e) => {
                                if (confirmPassword.length < 50) { setConfirmPassword(e.target.value); }
                            }}
                            autoComplete="off"
                            required
                            fullWidth
                            variant="standard"
                        />
                        <br /><br />
                    </div>
                    <div className="centerdiv">
                        <button type="submit" className="btn btn-primary allbtn allbtnadd" value="Login">Activate Account</button>
                    </div>
                </form>
            );
        } else if (window.location.pathname.includes('/login/forgotpassword')) {
            formPage = (
                <form className="loginForm" onSubmit={onSubmitNewAccount}>
                    <img src={logo} className="img-responsive centeriimgs" style={{ maxWidth: "400px" }} />
                    <div className="content mt-5 centerheadingfd text-center">Finally, choose a new password</div>
                    {errorMessage !== '' ? <div style={{ maxWidth: '400px' }} className="alert alert-danger text-center" role="alert">{errorMessage}</div> : null}
                    <div className="modal-body modfields" style={{ paddingTop: '10px' }}>
                        <TextField
                            type="password"
                            name="password"
                            label="New password"
                            className={phoneerror ? phoneerror : ""}
                            value={password}
                            onChange={(e) => {
                                if (password.length < 50) { setPassword(e.target.value); }
                            }}
                            required
                            autoComplete="off"
                            fullWidth
                            variant="standard"
                        />
                        <h6 className="text-left">Include at least 1 number and 1 special character.</h6>
                        <br />
                        <TextField
                            type="password"
                            name="confirmpassword"
                            label="Retype new password"
                            className={phoneerror ? phoneerror : ""}
                            value={confirmPassword}
                            onChange={(e) => {
                                if (confirmPassword.length < 50) { setConfirmPassword(e.target.value); }
                            }}
                            autoComplete="off"
                            required
                            fullWidth
                            variant="standard"
                        />
                        <br /><br />
                    </div>
                    <div className="centerdiv">
                        <button type="submit" className="btn btn-primary allbtn allbtnadd" value="Login">Submit</button>
                    </div>
                </form>
            );
        } else if (window.location.pathname.includes('/login/forget-password')) {
            formPage = (
                <form className="loginForm" onSubmit={onForgetPassword}>
                    <img src={logo} className="img-responsive centeriimgs" style={{ maxWidth: "400px" }} />
                    {errorMessage !== '' ? <div style={{ maxWidth: '400px' }} className="alert alert-danger text-center" role="alert">{errorMessage}</div> : null}
                    {!processed ? (
                        <>
                            <div className="modal-body modfields" style={{ paddingTop: '10px' }}>
                                <div className="content mt-5 centerheadingfd">Let's find your account. Please enter the registered email address</div>
                                <br />
                                <br />
                                <TextField
                                    type="text"
                                    name="registeredEmail"
                                    label="Email Address"
                                    className={phoneerror ? phoneerror : ""}
                                    value={registeredEmail}
                                    onChange={(e) => setRegisteredEmail(e.target.value)}
                                    required
                                    autoComplete="off"
                                    fullWidth
                                    variant="standard"
                                />
                                <br /><br />
                            </div>
                            <div className="centerdiv">
                                <button type="submit" className="btn allbtn" style={{ backgroundColor: "#15599F" }} value="Login">Send Email</button>
                                <div style={{ paddingTop: '20px', marginTop: "30px" }}>
                                    Already have an account? <a style={{ float: "center", paddingTop: '10px' }} href="/login"> Please login</a>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="modal-body modfields" style={{ paddingTop: '10px' }}>
                                <div className="content mt-5 centerheadingfd" style={{ marginBottom: "0px" }}>We just emailed you a link</div>
                                <div style={{ fontSize: '12px' }}>Please check your email and click the secure link.</div>
                                <br />
                            </div>
                            <div className="centerdiv">
                                <div>
                                    <div>
                                        <button type="submit" className="btn allbtn" value="Login" style={{ backgroundColor: "#15599F" }}>Resend link</button>
                                    </div>
                                    <div style={{ marginTop: "31px" }}>
                                        <a href="" style={{ float: 'center', marginTop: '20px', paddingTop: '20px' }} onClick={() => {
                                            setProcessed(false);
                                            setRegisteredEmail("");
                                        }}>
                                            Try different email
                                        </a>
                                    </div>
                                </div>
                                <br /><br />
                                <div style={{ fontSize: '12px', float: 'center', marginTop: '40px', marginLeft: '2px' }}>
                                    If you don't see your mail in inbox, try to search in spam folder.
                                </div>
                                <div style={{ fontSize: '12px', float: 'center', marginLeft: '2px' }}>
                                    Lost access to your email.<br />
                                    Email at <a href="mailto:hello@okas.ai?Subject=Forget%20Password" target="_top">hello@okas.ai</a>
                                </div>
                            </div>
                        </>
                    )}
                </form>
            );
        }
        return formPage;

    }

    return (
        <div className="row marginnone text-center" style={{ height: '100%' }}>
            <SnackBar
                open={snackbarActive}
                handleSnackbarClose={() => setSnackbarActive(false)}
                message={snackbarMessage}
            />
            {loader && <Loader />}
            <div className="col-lg-4 col-md-4 col-xs-12 col-sm-12 login-page-height box-shadow-login-sm" style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                {/* <LoginForm onSubmit={submitForm}/> */}
                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-4 loginForm-width">
                    {!confirmWindow ? typeOfLogin() : null}
                    {/* {confirmationWindow()} */}
                    {confirmWindow && <ConfirmationWindow confirmWindow={confirmWindow} />}
                </div>
            </div>

            <div className="col-lg-8 col-md-8 paddingnone hidden-xs hidden-sm login-page-height">
                <div id="myCarousel" className="carousel slide" data-ride="carousel" style={{ height: '101%' }}>
                    <div className="carousel-inner" style={{ height: '100%' }}>
                        <div className="item active" style={{ height: '100%' }}>
                            <video autoPlay muted loop style={{ objectFit: "fill", height: '100%' }}>
                                <source src={bgvideo} type="video/mp4" />
                            </video>
                            <div>
                                <div className="carousel-caption" style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '0px' }}>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Box
                sx={{
                    height: "90px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 3, // Padding on both sides
                    backgroundColor: "#f8f8f8", // Adjust as needed
                    flexWrap: "wrap", // Makes it responsive
                }}
            >
                {/* Left Section */}
                <Box sx={{ textAlign: "left" }}>
                    <Typography variant="body2" sx={{ fontSize: "13px" }}>
                        OKAS understood that home is an exceptional space for people with class or taste for exclusivity.
                        <br />
                        Also, each member has their preferences and feel of living.
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                        <Link to="https://www.okas.ai/" target="_blank" rel="noopener noreferrer">
                            <img src={okasweb} alt="OKAS Website" style={{ width: "20px" }} />
                        </Link>
                        <Link to="mailto:hello@okas.ai">
                            <img src={okasmail} alt="Email OKAS" style={{ width: "20px" }} />
                        </Link>
                    </Box>
                </Box>

                {/* Right Section */}
                <Box sx={{ textAlign: "right" }}>
                    <Box sx={{ mb: 1 }}>
                        <img src={okaslogo} alt="OKAS Logo" style={{ width: "100px" }} />
                    </Box>
                    <Typography variant="body2" sx={{ fontSize: "11px" }}>
                        <Link to="/terms" target="_blank" rel="noopener noreferrer" sx={{ textDecoration: "none", color: "inherit" }}>
                            Terms & Conditions
                        </Link>
                    </Typography>
                    <Typography variant="body2">© OKAS.Ai 2019. All Rights Reserved.</Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    display: { xs: "block", sm: "block", md: "none", lg: "none" },
                    height: "50px", // Example: Adjust as needed
                    textAlign: "center",
                    backgroundColor: "#f8f9fa", // Optional: Light background
                    padding: "10px"
                }}
            >
                © OKAS.Ai 2019. All Rights Reserved.
            </Box>


            {confirmWindow && false && (
                <div className="selfmodal fade in" aria-hidden="false" data-backdrop="static" data-keyboard="false">
                    <div className="selfmodal-dialog" style={{ width: "50%" }}>
                        <div className="selfmodal-content">
                            <div className="modal-header">
                                <h4 className="modal-title h3 text-center">Confirmation Message</h4>
                            </div>
                            <div className="modal-body modfields">
                                <span className="fa">success icon</span>
                            </div>
                            <div className="modal-footer text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary allbtn"
                                    onClick={() => (window.location = "/login")}
                                >
                                    Login Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default LoginView;
